export default __webpack_public_path__ + "static/games-pc-9c4d97f3b0e84b0409584b8514042fdc.png";